/* eslint-disable key-spacing */
/* eslint-disable no-multi-spaces */
import React, { useContext } from 'react'
import { LiabilitiesContext } from '../../context'
import { InputFieldWithLabel, NumberFieldWithLabel } from '@components/Form/Fields'
import { getLabel } from './formService'

export const LiabilityFields = ({ values }) => {
  const { state } = useContext(LiabilitiesContext)
  const { formFields } = state

  return (
    formFields.map((field) =>
      <LiabilityField
        key={field}
        name={field}
        label={getLabel(field)}
        values={values}
      />
    )
  )
}

export const LiabilityField = ({ name, label, values }) => {
  if (name === 'name') {
    return <InputFieldWithLabel name={name} label={label} />
  } else if ( name === 'interest_rate') {
    return (
      <NumberFieldWithLabel
        name={name}
        value={values[name]}
        label={label}
        placeholder={0}
        precision={2}
      />
    )
  } else {
    return (
      <NumberFieldWithLabel
        name={name}
        value={values[name]}
        label={label}
        placeholder={0}
      />
    )
  }
}
